import { CircleAlert, CircleCheck, Info, Loader2, TriangleAlert } from "lucide-react";
import { Toaster as SonnerToaster, toast } from "sonner";
import { Icon } from "./icon";

/**
 * Mount once near the root; call `toast(...)` with translated text anywhere. Meridian's toast (docs/design/meridian.md)
 * is the inverse surface, with the tone's icon and at most one action ("Undo"), lifted by `shadow-overlay`.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      icons={{
        success: <Icon icon={CircleCheck} className="text-tone-done-dot" />,
        error: <Icon icon={CircleAlert} className="text-tone-problem-dot" />,
        warning: <Icon icon={TriangleAlert} className="text-tone-attention-dot" />,
        info: <Icon icon={Info} className="text-on-inverse-link" />,
        loading: <Icon icon={Loader2} className="animate-spin text-on-inverse-muted" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "flex w-[356px] max-w-[calc(100vw-2rem)] items-center gap-2.5 rounded-(--radius-control) bg-inverse px-3 py-2.5 font-sans text-small text-on-inverse shadow-overlay",
          title: "font-medium",
          description: "text-on-inverse-muted",
          actionButton: "ms-auto shrink-0 font-medium text-on-inverse-link hover:underline",
          cancelButton: "shrink-0 text-on-inverse-muted hover:underline",
          icon: "flex shrink-0",
        },
      }}
    />
  );
}

export { toast };
